import client from './client';
import type { UserPreferences } from '@/types/api';

export type { UserPreferences };

export const preferencesApi = {
  getMine: async (): Promise<UserPreferences> => {
    const { data } = await client.get<UserPreferences>('/preferences/me');
    return data;
  },

  updateMine: async (prefs: Partial<UserPreferences>): Promise<UserPreferences> => {
    const { data } = await client.put<UserPreferences>('/preferences/me', prefs);
    return data;
  },
};
